module.exports = __webpack_public_path__ + "static/media/18ECA36.e2f34f0b.jpg";